//Module Keys
let locales = {
    dashboard_device_model: "Modelo de dispositivo",
    dashboard_3_days: "0-3 días",
    dashboard_5_days: "4-5 días",
    dashboard_10_days: "6-10 días",
    dashboard_15_days: "11-15 días",
    dashboard_16_days: "+16 días",
};

//Merge Views
import createEditChart from 'Modules/dashboard/views/.components/chart/.components/forms/createEditChart/lan/es';
import deleteChart from 'Modules/dashboard/views/.components/chart/.components/deleteChart/lan/es';
import createEditDashboard from 'Modules/dashboard/views/.components/dashboardPanel/.components/createEditDashboard/lan/es';
import deleteDashboard from 'Modules/dashboard/views/.components/dashboardPanel/.components/deleteDashboard/lan/es';
import dragDropContainer from 'Modules/dashboard/views/.components/dashboardPanel/.components/dragDropContainer/lan/es';
import createEditGadget from 'Modules/dashboard/views/.components/dashboardPanel/.components/gadgets/.components/createEditGadget/lan/es';
import menuActions from 'Modules/dashboard/views/.components/dashboardPanel/.components/menuActions/lan/es';
import vidFleetClipRequestsDetails from 'Modules/dashboard/views/.components/dashboardPanel/.components/vidFleetClipRequestsDetails/lan/es';
import devicesByStatus from 'Modules/dashboard/views/.components/chart/.components/devicesByStatus/lan/es';
import lastReadingDetails from 'Modules/dashboard/views/.components/dashboardPanel/.components/lastReadingDetails/lan/es';

locales = {
    ...locales,
    ...createEditChart,
    ...deleteChart,
    ...createEditDashboard,
    ...deleteDashboard,
    ...dragDropContainer,
    ...createEditGadget,
    ...menuActions,
    ...vidFleetClipRequestsDetails,
    ...devicesByStatus,
    ...lastReadingDetails,
};


export default locales;